import { createContext } from 'react';

interface ToolDialogBackContextProps {
  backFn: (() => void) | null;
  setBackFn: (fn: (() => void) | null) => void;
}

const ToolDialogBackContext = createContext<ToolDialogBackContextProps>({
  backFn: () => {},
  setBackFn: () => {},
});

export default ToolDialogBackContext;
